// extracted by mini-css-extract-plugin
export default {"containerVerticalStepper":"stepper-styles_containerVerticalStepper__404h+","verticalStepperSxElement":"stepper-styles_verticalStepperSxElement__9uNuR"};